import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ContractSlice } from '@classes/contract-slice';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ContractSliceService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/contractSlice';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getContractSlices(): Observable<Array<ContractSlice>> {
    return this.http.get<Array<ContractSlice>>(this.basePath);
  }

  getContractSlice(id: string): Observable<ContractSlice> {
    return this.http.get<ContractSlice>(`${this.basePath}/${id}`);
  }
  getContractSlicesByContractID(contractId: string): Observable<Array<ContractSlice>> {
    return this.http.get<Array<ContractSlice>>(`${this.basePath}/GetByContractID?contractId=${contractId}`);
  }

  createOrUpdateContractSlice(contractSlice?: ContractSlice): Observable<ContractSlice> {
    if (contractSlice?.id) {
      //update
      const url = `${this.basePath}/${contractSlice?.id}`;
      return this.http.patch<any>(url,
        contractSlice).pipe(map(m => {
          return m
        }));
    } else {
      //create

      return this.http.post<any>(this.basePath,
        contractSlice
      ).pipe(map(m => {
        return m
      }));
    }
  }
  deleteContractSlice(contractSliceId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${contractSliceId}`;
    return this.http.delete(url);
  }
}
